import DialogFactory from '@kso/ui/lib/Dialog';
import '@kso/ui/lib/Dialog/style.css';
import Index from '@kso/ui/lib/FileMove';
import '@kso/ui/lib/FileMove/style.css';
import KSecureTeamTips from '@kso/ui/lib/SecureTeamTips';
import '@kso/ui/lib/SecureTeamTips/style.css';

var index = DialogFactory({
  entry: function entry(_ref) {
    var showSecureTips = _ref.showSecureTips;
    return showSecureTips ? 'KSecureTeamTips' : 'KFileMove';
  },
  pages: [{
    className: 'k-dialog-page-file-move',
    width: '822px',
    body: Index,
    footer: null,
    closeOnClickModal: false
  }, {
    className: 'k-dialog-secure-tips',
    width: '420px',
    body: KSecureTeamTips,
    footer: null,
    closeOnClickModal: false
  }]
});

export { index as default };
